import ArticlesGrid from '../../../molecules/journal/articlesGrid';
import JournalBanner from '../../../molecules/journal/journalBanner';
import JournalNavigation from '../../../molecules/journal/journalNavigation';
import { Category } from '@srcDS/js/components/templates/journal/journalArticle/JournalArticle';
import { Banner } from '@srcDS/js/components/molecules/journal/journalBanner/JournalBanner';
import { PaginationState } from '@srcDS/js/components/molecules/journal/articlesGrid/ArticlesGrid';
import styles from './JournalCategory.module.scss';

export interface Article {
  [key: string]: any;
}

export interface JournalCategoryProps {
  isSSR: boolean;
  categories: Category[];
  pageTitle: string;
  activeSlug: string;
  title?: string;
  articles: Article[];
  teaser?: React.ReactNode;
  paginationState?: PaginationState;
  banner?: Banner;
  description?: string;
  backgroundColor?: string;
  articleSection?: string;
  hideBreadcrumbs?: boolean;
}

const JournalCategory: React.FC<JournalCategoryProps> = ({
  isSSR,
  categories,
  pageTitle,
  activeSlug,
  title = 'Journal',
  articles,
  teaser,
  paginationState,
  banner,
  description,
  backgroundColor,
  articleSection,
  hideBreadcrumbs,
}) => {
  return (
    <div style={{ backgroundColor }}>
      <JournalNavigation
        categories={categories}
        title={title}
        description={description}
        pageTitle={pageTitle}
        activeSlug={activeSlug}
        hideBreadcrumbs={hideBreadcrumbs}
      />
      <div className={styles.container}>
        {banner && (
          <div className={styles.bannerContainer}>
            <JournalBanner isSSR={isSSR} banner={banner} />
          </div>
        )}
        <ArticlesGrid
          isSSR={isSSR}
          articles={articles}
          teaser={teaser}
          paginationState={paginationState}
          articleSection={articleSection}
        />
      </div>
    </div>
  );
};

export default JournalCategory;
